<div>
    <div style="background-color: white;">
        <app-newfuels parent="fleetassets" [fleet_id]=""></app-newfuels>
    </div>
</div>
